module.exports = __webpack_public_path__ + "static/media/cancel.b7120133.svg";